import type { Theme } from "@mui/material";
import { useMediaQuery } from "@mui/material";

import { BreakPointsType, BreakPoints } from "src/types/responsiveness";

export const useIsMobile = () => {
  const isMobile = useMediaQuery((theme: Theme) => {
    return theme.breakpoints.down("md");
  });

  const isMd = useMediaQuery((theme: Theme) => {
    return theme.breakpoints.between("md", "lg");
  });

  const isLg = useMediaQuery((theme: Theme) => {
    return theme.breakpoints.between("lg", "xl");
  });

  const isXLg = useMediaQuery((theme: Theme) => {
    return theme.breakpoints.up("xl");
  });

  let viewName: BreakPointsType = BreakPoints.isMobile;

  if (isMd) {
    viewName = BreakPoints.isMd;
  }

  if (isLg) {
    viewName = BreakPoints.isLg;
  }

  if (isXLg) {
    viewName = BreakPoints.isXLg;
  }

  return { isMobile, isMd, isLg, isXLg, viewName };
};
